import { render, staticRenderFns } from "./apiDocument.vue?vue&type=template&id=5e150782&scoped=true&"
import script from "./apiDocument.vue?vue&type=script&lang=js&"
export * from "./apiDocument.vue?vue&type=script&lang=js&"
import style0 from "./apiDocument.vue?vue&type=style&index=0&id=5e150782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e150782",
  null
  
)

export default component.exports